var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"desc"},[_vm._t("desc")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }